/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import"../../../../chunks/vec2f64.js";import"../core/shaderModules/Float2DrawUniform.js";import"../core/shaderModules/interfaces.js";import"../core/shaderModules/ShaderBuilder.js";import"../core/shaderModules/Texture2DDrawUniform.js";import"../lib/VertexAttribute.js";export{H as HighlightDownsampleDrawParameters,b as build}from"../../../../chunks/HighlightDownsample.glsl.js";
